webpackJsonp([221813830287272],{

/***/ 1586:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TreatmentTimeIntervalInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"begin","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"end","type":{"kind":"SCALAR","name":"DateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-treatment-time-interval-input-91a1a0037e24c40ec18b.js